export default function getTrupeerEmbedLink(trupeerId: string) {
  return `https://app.trupeer.ai/embed/${trupeerId}`;
}
